import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-xing', 'BrandXing', [["path",{"d":"M16 21l-4 -7l6.5 -11"}],["path",{"d":"M7 7l2 3.5l-3 4.5"}]]);